<template>
  <div class="session">
    <Topbar 
    countDown="00:30:29" 
    name="Erlando" 
    localtime="06:00 AM"
    />
    <div style="height: 60px"></div>
    <div class="session-content" dir="rtl">
      <div class="profile__session">
          <img :src="require('@/assets/logo.png')" alt="">
          <h3>Erlando</h3>
          <button class="btn btn-primary">Notify</button>
        </div>
      <div class="take-note" v-b-modal.modal-center @click="newNote = true">
        <span>+</span>
        <span>Take a Note</span>
      </div>
      
      <div class="notes-area">
         <Note 
         v-for="(note, index) in notes" 
         :key="index" 
         :content="note.note" 
         :activeColor="note.color" 
         :ni="index" 
          @changeNoteColor="changeColor"
          @editMe="modalValue"
          @deleteMe="deleteNote"
          />
       </div>
      
      
      <transition name="fade">
      <Settings dir="ltr" class="setting" v-if="setting" />
      </transition>
      <User-vide class="user-video"/>
    </div>
    <Downbar @end-session="$emit('end-session')" name="Erlando" :menu="setting" :chat="chat" @showSetting="setting=!setting" @toogleChats="chat=!chat"/>
    <div class="overlay" @click="setting=false"  v-if="setting" ></div>
    <Chat :chat="chat" @closeMe="chat=false"/>
    

  <b-modal id="modal-center" centered title="Your Note" @ok="saveNote">
    <div class="input-note">
      
      <textarea class="form-control" v-model="note" rows="4"></textarea>
    </div>
  </b-modal>
  
  </div>
</template>

<script>
// @ is an alias to /src
import Settings from '@/components/sessions/Settings'
import Topbar from '@/components/sessions/Topbar'
import Note from "@/components/sessions/Note";
import Downbar from '@/components/sessions/Downbar'
import Chat from '@/components/sessions/Chat'
import UserVide from '@/components/sessions/UserVide'
export default {
  name: 'Home',
  data(){
    return{
      setting: false,
      chat: false,
      note: '',
      currentNote: 0,
      notes: [
        {note: ' Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type. ', color:1},
        {note: ' Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type. ', color:2},
        {note: ' Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type. ', color:3},
        {note: ' Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type. ', color:4},
        {note: ' Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type. ', color:5}
      ],
      newNote: false
      
    }
  },
  components: {
    Settings,
    Topbar,
    Note,
    Downbar,
    Chat,
    UserVide
  },
  methods: {
    deleteNote(e){
      
      this.notes.splice(e.ni, 1)  
      
      

    },
    modalValue(e){
      this.currentNote = e.ni
      this.note = this.notes[e.ni].note
    },
    saveNote(){
      if(this.newNote){
          this.notes.push(
            {note: this.note, color: 1}
          )
          this.newNote = false
        return
      }else{
        this.notes[this.currentNote].note = this.note
      }
      this.note = ""
    },
    changeColor(e){
    
      this.notes[e.ni].color = e.ci
    },
    
  }
}
</script>

<style lang="scss" scoped>
  .session{
   
     .overlay{
          position: fixed;
          top:0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 3;
          background: transparent;
        }
    .session-content{
      position: relative;
      background: #474D52;
      min-height: calc(100vh - 140px );
      padding-top: 120px;
      .setting{
        position: fixed;
        bottom: 90px;
        left: 50%;
        z-index: 4;
        transform: translateX(-50%);
      }
      .notes-area{
        float: right;
        margin-right: 24px;
        display: grid;
        
        grid-template-rows: 154px 154px;
        grid-gap: 10px;
        grid-template-columns: repeat(auto-fill, 144px);
        grid-auto-flow: column;
        justify-content: end;
      }
      .take-note{
        cursor: pointer;
        position: absolute;
        top:24px;
        right: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 100px;
        height: 70px;
        background: rgba(255, 255, 255, 0.1);
        background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='white' stroke-width='2' stroke-dasharray='6' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");

        span{
          font-family: 'Nunito', sans-serif;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 19px;
          color: #FFFFFF;
        }
        &:hover{
          box-shadow: 0px 0px 4px 0px #888;
        }
      }
    }
    .profile__session{
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 104px;
      
      img{
        width: 80px;
        height: 80px;
        border-radius: 50%;
        cursor: pointer;
      }
      h3{
        cursor: pointer;
        font-family: 'Nunito', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 33px;
        color: #FFFFFF;
      }
      button{
        padding: 0;
        width: 84px;
        height: 28px;
        background: #557EFB;
        border-radius: 4px;
        font-family: 'Nunito', sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        color: #FFFFFF;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .user-video{
      position: absolute;
      bottom: 24px;
      left: 24px;
    }

  }
  @media (max-width: 991px){
        .user-video{
          position: fixed !important;
          width: 100px;
          bottom: 105px !important;
        }
    }

  @media (max-width: 768px){
    .session-content{
      display: flex;
      justify-content: center;
    }
    .session .session-content{
      padding-top: 180px;
    }
    .session .profile__session{
      top: 10px;
    }
    .session-content .notes-area{
      margin: 0 5%;
      grid-auto-flow: row !important;
      grid-template-columns: 144px span 144px !important;
      grid-template-rows:repeat(auto-fill, 154px) !important;
    }
  }
  @media (max-width: 560px){
    .setting{
      bottom: 130px !important;
      width: 100%;
      min-width: unset;
      .settings .set__settings .form-control{
        width: 50%;
      }
    }
  }
</style>
